import React, { useState } from "react";
import { ChevronDown, RotateCcw, SlidersHorizontal, X } from "lucide-react";
import { describeValue, hasValue } from "./advance-filter.helpers";

// Strip under the drawer header: how many filters are selected (click to list
// them as removable chips) and a "Clear all" that empties the selection.
// Nothing reaches the table until Apply.
const FilterSummaryBar = ({ fields, draft, optionsByKey, errors, timeFormat, onClearField, onClearAll }) => {
  const [showChips, setShowChips] = useState(false);
  const activeFields = fields.filter((field) => hasValue(field, draft[field.key]));
  const count = activeFields.length;

  return (
    <div className="px-4 py-3 bg-surface_alt border-b border-border">
      <div className="flex items-center justify-between gap-3">
        {count > 0 ? (
          <button
            type="button"
            onClick={() => setShowChips((prev) => !prev)}
            aria-expanded={showChips}
            className="inline-flex items-center gap-1.5 h-8 px-3 rounded-md bg-primary_tint text-primary text-xs font-semibold"
          >
            <SlidersHorizontal size={14} />
            {count} {count === 1 ? "Filter" : "Filters"} Selected
            <ChevronDown size={14} className={showChips ? "rotate-180" : ""} />
          </button>
        ) : (
          <span className="inline-flex items-center gap-1.5 h-8 text-xs font-medium text-text_muted">
            <SlidersHorizontal size={14} />
            No filters selected
          </span>
        )}

        <button
          type="button"
          onClick={onClearAll}
          disabled={count === 0}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary hover:underline disabled:text-text_muted disabled:opacity-60 disabled:no-underline disabled:cursor-not-allowed"
        >
          <RotateCcw size={13} />
          Clear All
        </button>
      </div>

      {showChips && count > 0 && (
        <div className="mt-2.5 flex flex-wrap gap-1.5">
          {activeFields.map((field) => {
            const summary = describeValue(field, draft[field.key], optionsByKey[field.key], timeFormat);
            const invalid = !!errors[field.key];
            return (
              <span
                key={field.key}
                title={`${field.label}: ${summary}`}
                className={`inline-flex items-center gap-1 max-w-full pl-2 pr-0.5 py-0.5 rounded-md border text-[11px] ${
                  invalid ? "border-danger_border bg-danger_bg text-danger" : "border-border bg-surface text-text_secondary"
                }`}
              >
                <span className="flex-shrink-0">{field.label}:</span>
                <span className={`min-w-0 truncate font-semibold ${invalid ? "" : "text-text_primary"}`}>{summary}</span>
                <button
                  type="button"
                  onClick={() => onClearField(field.key)}
                  aria-label={`Clear ${field.label}`}
                  className="flex-shrink-0 p-0.5 rounded-sm text-text_muted hover:text-text_primary hover:bg-surface_alt"
                >
                  <X size={11} />
                </button>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilterSummaryBar;
